export default __webpack_public_path__ + "static/media/warning--children--g6.52ca9670.png";